import { Box } from "@chakra-ui/react";
import FormFieldWrapper, {
  ContentComponents,
  FormFieldWrapperProps,
} from "components/Shared/Forms/FormFieldWrapper";

export function defaultRenderContentInline({
  label,
  helpText,
  input,
  error,
}: ContentComponents) {
  return (
    <>
      <Box className="label-parts" mt={3} flex="1 1 auto">
        {label}
        {helpText}
      </Box>

      <Box className="input-parts" flex="1 1 100%">
        {input}
        {error}
      </Box>
    </>
  );
}

export type FormFieldWrapperInlineProps = FormFieldWrapperProps;

export default function FormFieldWrapperInline({
  renderContent = defaultRenderContentInline,
  ...rest
}: FormFieldWrapperInlineProps) {
  return (
    <FormFieldWrapper renderContent={renderContent} display="flex" {...rest} />
  );
}
